import StyledInput from "../common/inputs/StyledInput";
import {
  StyledInputLabelProps,
  StyledInputProps,
  StyledInputValidationProps,
} from "../common/inputs/StyledInput/StyledInput";

const MIN_NUM = 2;

const strings = {
  tooHigh: (max: number) => `Max value is ${max}`,
  tooLow: `Min value is ${MIN_NUM}`,
};

type Props = Omit<StyledInputProps, "value"> & {
  value: number;
  max: number;
  invalid?: undefined;
} & StyledInputLabelProps &
  StyledInputValidationProps;

export default function StyledNumPaymentsInput({
  value,
  max,
  ...props
}: Props) {
  let validationMessages: string[] = [];
  if (value > max) {
    validationMessages = [strings.tooHigh(max)];
  } else if (value < MIN_NUM) {
    validationMessages = [strings.tooLow];
  }

  return (
    <StyledInput
      {...props}
      value={isNaN(value) ? "" : value}
      max={max}
      min={MIN_NUM}
      type="number"
      maxLength={2}
      validationMessages={validationMessages}
    />
  );
}
